/*
 * File: form-header-translation.ts
 * File Created: 2026-01-22 21:30:00
 * Author: Val Liu
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseFormComponent } from "@root/components/form/core/lib/base-form-component";
import { UITag } from "@root/core/tags";

@UITag.setDefault({
    uiSubmitIgnore: true,
})
@Component
export default class FormHeaderTranslation extends BaseFormComponent {
    @Prop({ type: Number, default: 1 })
    step!: number;

    @Prop({
        type: Array,
        default: () => ["w_TranslationJobStepUpload", "w_TranslationJobStepEstimate"],
    })
    labels!: string[];

    @Prop({ type: Boolean, default: false })
    compact!: boolean;

    stepClass(index: number) {
        if (this.step > index) return "completed";
        if (this.step === index) return "active";
        return "";
    }

    stepIcon(index: number) {
        if (this.step > index) {
            return "<i class='fas fa-check'></i>";
        }
        return String(index);
    }
}
